import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

export type InstructionsSpanTypographyProps = React.HTMLAttributes<HTMLSpanElement> & {
    className?: string;
};

function InstructionsSpanTypography({ className, ...props }: InstructionsSpanTypographyProps) {
    return <span className={cn('text-foreground text-sm', className)} {...props} />;
}

export default InstructionsSpanTypography;
